<template>
  <slot v-if="$slots.mobile && mobile" name="mobile" />
  <slot v-if="$slots.desktop && !mobile" name="desktop" />
</template>

<script lang="ts" setup>
import { useDisplay } from "vuetify";

const { mobile } = useDisplay();
</script>
